import Vue, { PluginObject, VueConstructor } from 'vue';
import { eventBus } from '@/common/eventBus';
import * as events from '@/metrix/events';

export class MetrixService {
    $emit(eventName: string, payload: any) {
        if (Object.keys(payload || {}).length) {
            eventBus.$emit(eventName, payload);
        } else {
            console.warn(`[metrix]: event ${eventName} has empty payload`);
        }
    }
}

export const MetrixPlugin: PluginObject<Vue> = {
    install(Vue: VueConstructor) {
        const service = new MetrixService();
        Vue.prototype.$metrix = service;
        Vue.prototype.$metrixEvents = events;
    },
};
